export default class BackendCaller {
    private apiURL: string;

    constructor(apiUrl: string) {
        this.apiURL = apiUrl;
    }

    public async callBackendService(endpoint: string, data: Record<string, unknown> ): Promise<Response> {
        const response = await fetch(`${this.apiURL}/${endpoint}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });
        return response;
    }
}
